import { HTMLAttributes } from 'react';
import { twMerge } from 'tailwind-merge';
/**
 * Компонент для отображения iframe игры. Можно использовать самостоятельно, но лучше всего использовать вместе с хуком
 * Можно передать объект style, возвращаемый хуком
 *
 * @todo Сделать так, чтобы хук учитывал высоту футера для мобильных устройств
 */
export function GameFrame({
  gameUrl,
  style,
  isFullscreen = false,
  className
}: {
  gameUrl?: string;
  isFullscreen?: boolean;
  style?: HTMLAttributes<HTMLIFrameElement>['style'];
  className?: string;
}) {
  if (!gameUrl) return null;
  return (
    <iframe
      style={style}
      src={gameUrl}
      id="game-iframe"
      className={twMerge(
        'transition-all w-full lg:w-[80%] lg:mx-auto',
        isFullscreen ? 'lg:w-full' : '',
        className
      )}
      allow="autoplay; fullscreen 'none'"
      allowFullScreen
      seamless
    />
  );
}
